// ✅ Start Turbo & Rails UJS
import "@hotwired/turbo-rails";
import Rails from "@rails/ujs";

Rails.start();

import * as ActiveStorage from "@rails/activestorage"
ActiveStorage.start()

// ✅ Stimulus setup
import "./controllers";

// ✅ Optional: global crypto helpers or debugging
import { waitForSessionKey, decryptBubble } from "./helpers/session_key";
window.waitForSessionKey = waitForSessionKey;
window.Gum = { decryptBubble };

console.log("✅ app/frontend/application.js loaded");

const SESSION_RECOVERY_MESSAGE = "Your session expired or you were logged out automatically after 15min of inactivity. Reloading your pinball console."

function sessionRecoveryUrl(loginUrl = "/login") {
  const url = new URL(loginUrl, window.location.origin)
  url.searchParams.set("session_expired", "1")
  return url.toString()
}

function redirectForExpiredSession(loginUrl) {
  if (window.__pinballSessionRecoveryRedirecting) return

  window.__pinballSessionRecoveryRedirecting = true
  try {
    window.sessionStorage?.setItem("pinball:session_recovery_message", SESSION_RECOVERY_MESSAGE)
  } catch (_) {
  }
  window.location.href = sessionRecoveryUrl(loginUrl)
}

document.addEventListener("turbo:before-fetch-response", (event) => {
  const response = event.detail?.fetchResponse?.response
  if (!response) return

  const expiredHeader = response.headers.get("X-Pinball-Session-Expired") === "1"
  const expiredStatus = response.status === 401 || response.status === 419
  if (!expiredHeader && !expiredStatus) return

  event.preventDefault()
  redirectForExpiredSession(document.body?.dataset?.idleTimeoutLoginUrlValue || "/login")
})

// Force full-page navigation for FM and /extras/:id links to avoid CORS preflights
document.addEventListener("turbo:click", (event) => {
  const a = event.target.closest('a[href]');
  if (!a) return;

  try {
    const url = new URL(a.href, window.location.origin);

    const isFmHost   = url.hostname === "fm.313.cash";
    const isExtrasId = /^\/extras\/\d+$/i.test(url.pathname);

    if (isFmHost || isExtrasId) {
      event.preventDefault();
      window.location.href = url.href; // hard navigation, no fetch/XHR, no CORS
    }
  } catch (_) {
    // ignore
  }
});
